import Vue from 'vue'
import VueResource from 'vue-resource'
import mixins from '../mixins.js'
import datePicker from '../../component/datePicker.vue'
import moment from 'moment'
import Checkbox from '../../component/simple-form/checkbox.vue'
import Multiselect from '../../component/dccore-form/multiselect.vue'
import Singleselect from '../../component/dccore-form/singleselect.vue'
import { TEAM_TYPES } from '@const/common'

require('bootstrap')

if ($('#production_list_report').length) {
  Vue.use(VueResource)
  new Vue({
    el: '#production_list_report',
    components: {
      datePicker,
      Checkbox,
      Multiselect,
      Singleselect
    },
    mixins: [mixins],
    data: {
      date: moment().locale('pl').format('YYYY-MM-DD'),
      skipMultimedia: true,
      dateType: null,
      teamType: null,
      productionTeams: [],
      unfoldingTeams: [],
      allProductionTeams: true,
      allUnfoldingTeams: true,
      canGenerateComponentMealReport: false,
      options: {
        productionTeams: [],
        unfoldingTeams: [],
      }
    },
    computed: {
      isProductionTeamsDisabled() {
        return this.teamType !== TEAM_TYPES.PRODUCTION && this.teamType !== null
      },
      isUnfoldingTeamsDisabled() {
        return this.teamType !== TEAM_TYPES.UNFOLDING
      },
      isDateTypeDisabled() {
        return this.teamType === TEAM_TYPES.UNFOLDING
      },
      isGeneratePdfDisabled() {
        let notSetProductionTeam = false
        let notSetUnfoldingTeam = false

        if (this.teamType === TEAM_TYPES.PRODUCTION && this.allProductionTeams === false && this.productionTeams.length === 0 ) {
          notSetProductionTeam = true
        }

        if (this.teamType === TEAM_TYPES.UNFOLDING && this.allUnfoldingTeams === false && this.unfoldingTeams.length === 0 ) {
          notSetUnfoldingTeam = true
        }

        return this.teamType === null || this.dateType === null || this.date === null || notSetProductionTeam || notSetUnfoldingTeam
      },
      isGeneratePdfComponentMealDisabled() {
        if (this.teamType !== TEAM_TYPES.PRODUCTION || this.isGeneratePdfDisabled) {
          return true
        }

        this.checkCanGenerateComponentMealReport()

        return !this.canGenerateComponentMealReport
      },
    },
    watch: {
      'teamType': function () {
        if (this.teamType === TEAM_TYPES.UNFOLDING) {
          this.dateType = 'delivery_date'
        }
      },
      'productionTeams': function () {
        if (this.productionTeams && this.productionTeams.length === 0) {
          this.allProductionTeams = true
        }
      },
      'unfoldingTeams': function () {
        if (this.unfoldingTeams && this.unfoldingTeams.length === 0) {
          this.allUnfoldingTeams = true
        }
      },
    },
    mounted: function () {
      this.getProductionTeams()
      this.getUnfoldingTeams()
    },
    created: function () {
      this.DATE_TYPES = [
        {
          id: 'delivery_date',
          name: 'Data dostawy'
        },
        {
          id: 'production_date',
          name: 'Data produkcji'
        }
      ]
      this.TEAM_TYPE_OPTIONS = [
        {
          id: TEAM_TYPES.PRODUCTION,
          name: Translator.trans('production_reports.report.production'),
        },
        {
          id: TEAM_TYPES.UNFOLDING,
          name: Translator.trans('production_reports.report.unfolding'),
        }
      ]
    },
    methods: {
      generatePdf() {
        switch (this.teamType) {
          case TEAM_TYPES.PRODUCTION: this.generateProductionPdf()
            break
          case TEAM_TYPES.UNFOLDING: this.generateUnfoldingPdf()
            break
        }
      },
      generateProductionPdf() {
        $(location).attr('href', Routing.generate('production_list_production_report_generate_pdf', {
          dateType: this.dateType,
          date: this.date,
          skipMultimedia : this.skipMultimedia ? 1 : 0,
          allProductionTeams: this.allProductionTeams ? 1 : 0,
          productionTeams: this.productionTeams,
        }))
      },
      generateUnfoldingPdf() {
        $(location).attr('href', Routing.generate('production_list_unfolding_report_generate_pdf', {
          dateType: this.dateType,
          date: this.date,
          skipMultimedia : this.skipMultimedia ? 1 : 0,
          allUnfoldingTeams: this.allUnfoldingTeams ? 1 : 0,
          unfoldingTeams: this.unfoldingTeams,
        }))
      },
      generatePdfComponentMeal() {
        $(location).attr('href', Routing.generate('production_list_production_component_meal_report_generate_pdf', {
          dateType: this.dateType,
          date: this.date,
          skipMultimedia : this.skipMultimedia ? 1 : 0,
          allProductionTeams: this.allProductionTeams ? 1 : 0,
          productionTeams: this.productionTeams,
        }))
      },
      getProductionTeams() {
        let url = Routing.generate('api_get_active_production_teams', { context: 'dropdown' })
        this.loading++
        this.$http.get(url).then(response => {
          this.options.productionTeams = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
      },
      getUnfoldingTeams() {
        let url = Routing.generate('api_get_active_unfolding_teams', { context: 'dropdown' })
        this.loading++
        this.$http.get(url).then(response => {
          this.options.unfoldingTeams = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
      },
      checkCanGenerateComponentMealReport() {
        let url = Routing.generate('api_can_generate_production_list_component_meal_report', {
          context: null,
          dateType: this.dateType,
          date: this.date,
          allProductionTeams: this.allProductionTeams ? 1 : 0,
          productionTeams: this.productionTeams.length > 0 ? this.productionTeams : -1,
        })
        this.loading++
        this.$http.get(url).then(response => {
          this.canGenerateComponentMealReport = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
      },
    },
  })
}
